<div class="user-form">
  <div class="header"></div>
  <div class="content">
    <form #userForm="ngForm" (ngSubmit)="userVM.onPersonalDetailsFormSubmit()">
      <table>
        <tr *ngIf="userVM.currentUser.hasManageUsersPermission">
          <td class="field-title short">TENANT:<span class="red">*</span></td>
          <td>
            <icn-dropdown
              [position]="'bottom'"
              tabindex="1"
              class="dropdown"
              (selectedValuesChange)="userVM.onTenantDropdownChange($event)"
              [allowMultiple]="true"
              [(selectedValues)]="userVM.editableUser.managedTenantIds"
            >
              <icn-dropdown-item
                *ngFor="let tenant of userVM.allManagedTenants"
                [title]="tenant.name"
                [value]="tenant.id"
              ></icn-dropdown-item>
            </icn-dropdown>
          </td>
          <td>
            <a
              *ngIf="userVM.currentUser.isSuperUser"
              class="create-new-tenant-btn"
              [routerLink]=""
              (click)="userVM.createNewTenant()"
              >Create a New Tenant</a
            >
          </td>
        </tr>
        <tr>
          <td class="field-title short">
            FIRST NAME:<span class="red">*</span>
          </td>
          <td>
            <input
              tabindex="2"
              type="text"
              placeholder=""
              [(ngModel)]="userVM.editableUser.firstName"
              name="firstName"
              required
              minlength="1"
              maxlength="100"
            />
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('firstName', 'required')
              "
              >Required field</span
            >
          </td>
        </tr>

        <tr>
          <td class="field-title short">
            <span class="label"> LAST NAME:<span class="red">*</span> </span>
          </td>
          <td>
            <input
              tabindex="3"
              type="text"
              placeholder=""
              [(ngModel)]="userVM.editableUser.lastName"
              name="lastName"
              required
              minlength="1"
              maxlength="100"
            />
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('lastName', 'required')
              "
              >Required field</span
            >
          </td>
        </tr>

        <tr>
          <td class="field-title short">PHONE:<span class="red">*</span></td>
          <td>
            <input
              tabindex="4"
              type="tel"
              placeholder=""
              [(ngModel)]="userVM.editableUser.phone"
              name="phone"
              pattern="(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$"
              required
            />
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('phone', 'required')
              "
              >Required field</span
            >
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('phone', 'pattern')
              "
              >Phone number isn't valid</span
            >
          </td>
        </tr>
        <tr>
          <td class="field-title short">
            EMAIL/USERNAME<span class="red">*</span>
          </td>
          <td>
            <input
              tabindex="5"
              type="email"
              placeholder=""
              [(ngModel)]="userVM.editableUser.username"
              email
              (blur)="userVM.validateEmailExists($any($event.target).value)"
              name="username"
              required
              minlength="1"
              maxlength="100"
            />
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField(
                  'username',
                  'usernameExists'
                )
              "
              >This email already has been taken</span
            >
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('username', 'required')
              "
              >Required field</span
            >
            <span
              class="errorMsg"
              [hidden]="
                userVM.verifyPersonalDetailsFormField('username', 'email')
              "
              >Email is required and format should be
              <i>john&#64;doe.com</i></span
            >
          </td>
        </tr>
        <ng-container *ngIf="userVM.showPasswordFields">
          <tr>
            <td class="field-title short">
              PASSWORD:<span class="red">*</span>
            </td>
            <td>
              <input
                tabindex="6"
                type="password"
                placeholder=""
                [(ngModel)]="userVM.passwordFieldValue"
                name="passwordFieldValue"
                pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\D]{6,}$"
                required
                maxlength="30"
              />
              <span
                class="errorMsg"
                [hidden]="
                  userVM.verifyPersonalDetailsFormField(
                    'passwordFieldValue',
                    'required'
                  )
                "
                >Required field</span
              >
              <span
                class="errorMsg"
                [hidden]="
                  userVM.verifyPersonalDetailsFormField(
                    'passwordFieldValue',
                    'pattern'
                  )
                "
                >Password must be at least 6 characters and contain at least one
                number</span
              >
            </td>
          </tr>
          <tr>
            <td class="field-title short">
              CONFIRM PASSWORD:<span class="red">*</span>
            </td>
            <td>
              <input
                tabindex="7"
                type="password"
                placeholder=""
                [(ngModel)]="userVM.confirmPasswordFieldValue"
                name="confirmPasswordFieldValue"
                validateEqual="password"
                required
                minlength="1"
                maxlength="30"
              />
              <span
                class="errorMsg"
                [hidden]="
                  userVM.verifyPersonalDetailsFormField(
                    'confirmPasswordFieldValue',
                    'required'
                  )
                "
                >Required field</span
              >
              <span
                class="errorMsg"
                [hidden]="
                  userVM.verifyPersonalDetailsFormField(
                    'confirmPasswordFieldValue',
                    'validateEqual'
                  )
                "
                >Password mismatch</span
              >
            </td>
          </tr>
        </ng-container>
        <!--<tr>
          <td class="field-title short">TRIAL ENDS</td>
          <td>
            <input name="trialEndsDate" type="date" [value]="userVM.editableUser.trialEndsDate && userVM.checkDateFormat(userVM.editableUser.trialEndsDate)" (change)="userVM.updateTrialDateEventHandler($event)" />
          </td>
          <td></td>
        </tr>-->
      </table>
    </form>
  </div>
</div>
